import { useTranslation } from 'react-i18next';
import { isEnumValue } from '@/shared/lib';
import { setDocumentDirection } from '@/app/i18n';
import { UserLanguageCode } from '@/app/store/api/restApi';
import { selectAuthInitialized, useAppSelector } from '@/app/store';
import { useUpdateClientProfileMutation } from '@/entities';

export const useChangeLanguage = () => {
  const { i18n } = useTranslation();
  const [updateProfile] = useUpdateClientProfileMutation();
  const isAuthenticated = useAppSelector(selectAuthInitialized);

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
    setDocumentDirection(code);
    if (isEnumValue(UserLanguageCode, code) && isAuthenticated) {
      updateProfile({ updateClientProfileDto: { languageCode: code } });
    }
  };

  return { changeLanguage, currentLanguage: i18n.language };
};
